module.exports = __webpack_public_path__ + "static/media/no-assignments.667f591d.svg";